import React, {useRef, useEffect} from 'react';
import styled from 'styled-components'
import gsap from 'gsap'

const HeroContainer = styled.figure`
    background-color: #5538FF;
    margin: 0;
    color: #fff;
    height: 85vh;
    /* height: calc(var(--vh, 1vh) * 85); */
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
    visibility: hidden;
    
    &::before, &::after{
        content: '';
        position: absolute;
        top: 0;
        left:0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
    }
    
    &::before{
        background: radial-gradient(circle at 6% 25%,rgba(255,141,56,0.4) 0%,transparent 25%);
    }
    
    &::after{
        background: radial-gradient(circle at bottom 20% right 20%, rgba(163,96,255,1) 0%, transparent 20%);
    }

    .container{
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        position: relative;
        z-index: 2;
    }
    h1{
        margin: 0 auto;
        text-align: center;
        max-width: 830px;
        width: 100%;
        font-size: 60px;
        line-height: 64px;
        letter-spacing: -0.5px;
        font-weight: 500;

        .hero-line{
            margin: 0;
            height: 72px;
            overflow: hidden;

            span{
                display: inline-block;
                line-height: 1;
                opacity: 0;
                transform: translateY(100%);
            }
        }
    }

    @media screen and (max-width: 768px) {

        &::before{
            background: radial-gradient(circle at 5% 0%,rgba(255,141,56,0.3) 0%,transparent 45%);
        }
        &::after{
            background: radial-gradient(circle at bottom 5% right 5%,rgba(163,96,255,0.8) 0%,transparent 40%);
        }
        
        .container{
            background-image: none;
        }
        h1{
            font-size: 24px;
            line-height: 30px;
            letter-spacing: -0.1px;

            .hero-line{
                height: 32px;
            }
        }
    }
`;

const ContactSuccess = ({line1, line2}) => {

    let hero = useRef(null);
    let heading = useRef(null);

    var tl = gsap.timeline();

    useEffect(() => {

        const line1 = heading.firstElementChild;
        const line2 = heading.lastElementChild;

        tl.to(hero, {duration: 0, css: {visibility: 'visible'}})
        .to(hero, {duration: 1, y: 0, ease: "expo.out"})
        .to([line1.children, line2.children], {
            opacity: 1,
            duration: 0.4,
            y: 0,
            ease: "power3.inOut",
            stagger: {
                amount: 0.3
            }
        }, ">-1");
    })


    return (
        <HeroContainer  ref={el => hero = el}>
            <div className="container">
                <h1 ref={el => heading = el}><div className="hero-line"><span>{line1}</span></div> {line2 && <div className="hero-line"><span>{line2}</span></div>}</h1>
            </div>
        </HeroContainer>
    )
}

export default ContactSuccess
